import { render, staticRenderFns } from "./MarkerClient.vue?vue&type=template&id=31ce2ff0&scoped=true&"
import script from "./MarkerClient.vue?vue&type=script&lang=js&"
export * from "./MarkerClient.vue?vue&type=script&lang=js&"
import style0 from "./MarkerClient.vue?vue&type=style&index=0&id=31ce2ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce2ff0",
  null
  
)

export default component.exports